'use client';

import React, { FC } from 'react';
import { TypeNavFeatureProductFields } from '@/core/generated-types';
import { Image } from '@/components/ui';
import { Link } from '@/navigation';
import { buildLinkUrl } from '@/utils/linkBuilder';
import {
  CLICKED_ITEM_TYPES,
  PAGE_LOCATIONS,
  trackItemClickedEvent,
} from '@/utils/rudderstack';

interface NavFeaturedProductProps extends TypeNavFeatureProductFields {
  onClose?: () => void;
}

export const NavFeaturedProduct: FC<NavFeaturedProductProps> = ({
  entryName: _entryName,
  title,
  media,
  link,
  onClose,
}) => {
  const href = buildLinkUrl(link);

  return (
    <Link
      href={href}
      data-testid="nav-featured-product"
      className="py-3 md:py-0 first:pt-0 last:pb-0 hover:text-blue-deep hover:underline lg:block hidden"
      onClick={() => {
        trackItemClickedEvent({
          type: CLICKED_ITEM_TYPES.LINK,
          cta: title || '',
          pageLocation: PAGE_LOCATIONS.NAVIGATION,
          url: window.location.href,
        });

        onClose?.();
      }}
    >
      {media && <Image imageData={media} alt={media.fields.altText} />}
      <div className="text-sm mt-[6px]">{title}</div>
    </Link>
  );
};

export default React.memo(NavFeaturedProduct);
